import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store";
import Layout from "./components/shared/Layout";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import Logout from "./pages/Logout";
import { Toaster } from "react-hot-toast";
import ProtectedRoute from "./private/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";
import Students from "./pages/userManagement/Students";
import TeacherList from "./pages/userManagement/TeacherList";
import Attendance from "./pages/attendance/Attendance";
import PaperWiseReports from "./pages/attendance/PaperWiseReports";
import SemesterWiseReports from "./pages/attendance/SemesterWiseReports";
import DepartmentWiseReports from "./pages/attendance/DepartmentWiseReports";

const App = () => {
  return (
    <Provider store={store}>
      <AuthProvider>
        <Router>
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: "#363636",
                color: "#fff",
              },
              success: {
                duration: 3000,
                theme: {
                  primary: "green",
                  secondary: "black",
                },
              },
            }}
          />

          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/logout" element={<Logout />} />

            <Route
              path="/dashboard/*"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route
                index
                element={
                  <ProtectedRoute requiredPermissions={["view_dashboard"]}>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="students"
                element={
                  <ProtectedRoute requiredPermissions={["view_students"]}>
                    <Students />
                  </ProtectedRoute>
                }
              />
              <Route
                path="teacher-list"
                element={
                  <ProtectedRoute requiredPermissions={["view_teachers"]}>
                    <TeacherList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="attendance"
                element={
                  <ProtectedRoute requiredPermissions={["view_attendance"]}>
                    <Attendance />
                  </ProtectedRoute>
                }
              />
              <Route
                path="paper-wise-Reports"
                element={
                  <ProtectedRoute requiredPermissions={["view_attendance"]}>
                    <PaperWiseReports />
                  </ProtectedRoute>
                }
              />

              <Route
                path="semester-wise-Reports"
                element={
                  <ProtectedRoute requiredPermissions={["view_attendance"]}>
                    <SemesterWiseReports />
                  </ProtectedRoute>
                }
              />
              <Route
                path="department-wise-Reports"
                element={
                  <ProtectedRoute requiredPermissions={["view_attendance"]}>
                    <DepartmentWiseReports />
                  </ProtectedRoute>
                }
              />
            </Route>
          </Routes>
        </Router>
      </AuthProvider>
    </Provider>
  );
};

export default App;
